// import * as Constants from "../theme/constants";
// const baseUrl = Constants.apiBaseUrl;

// class Common {
//     //Get Base URL
//     getBaseUrl() {
//       return baseUrl;
//     }
// }

// AssetUtils.js

export const validateURL = (url) => {
  const parsed = new URL(url);
  return ["https:", "http:"].includes(parsed.protocol);
};
